import { apiCall } from "../../../../../_utils";
import { apiUrls } from "../../../../../_constants";

export const upLoadService = {
  submitPost,
  draftPost,
  getPost,
  updateDraftPost,
  getInstructorPost,
  getInstructor,
  getInstructorInterest,
  changePostStatus,
  getSpecificInstructorInterest,
  updateSubmitPost
};

function submitPost(request) {
  return apiCall("POST", `${apiUrls.posts.base}/submit`, request);
}


function updateSubmitPost(request,id) {
  return apiCall("PUT", `${apiUrls.posts.base}/submit/${id}`, request);
}

function draftPost(request) {
  return apiCall("POST", `${apiUrls.posts.base}/`, request);
}

function updateDraftPost(request, id) {
  return apiCall("PUT", `${apiUrls.posts.base}/${id}`, request);
}

function getPost(id) {
  return apiCall("GET", `${apiUrls.posts.base}/${id}`);
}

function getInstructor(id) {
  return apiCall("GET", `${apiUrls.instructors.base}/${id}`);
}

function getInstructorPost(id) {
  return apiCall("GET", `${apiUrls.posts.base}/${id}`);
}

function getInstructorInterest(params) {
  return apiCall("GET", apiUrls.interests.instructor, null, params);
}

function changePostStatus(id) {
  return apiCall("PUT", `${apiUrls.posts.revise}/${id}`);
}

function getSpecificInstructorInterest() {
  return apiCall("GET", apiUrls.interests.instructor);
}
